export default __webpack_public_path__ + "static/media/school_aboutus.62d5fe10.png";